<script lang="ts">
    import {onMount} from "svelte";
    import {MessageStore} from "../../../store/MessageStore";
    import {ImagePathConfig} from "../../../ImagePathConfig";

    const displayMilliSeconds = 3000;

    onMount(() => {
    });

    let doClosing: boolean = false;
    let closingTimeoutId: number = 0;
    let isShow: boolean = false;

    $: cornerMessage = MessageStore.cornerMessage;
    $: {
        // cornerMessage が変更された場合、表示を行う
        if ($cornerMessage != '') {
            isShow = true;
            doClosing = false;
            if (closingTimeoutId !== 0) {
                clearTimeout(closingTimeoutId);
            }
            closingTimeoutId = setTimeout(() => {
                doClosing = true;
                isShow = false;
            }, displayMilliSeconds);

        }
    }


    function onTransitionEnd() {
        if (doClosing) {
            cornerMessage.set('');
            doClosing = false;
        }
    }


</script>


<div class="corner-message-view"
     class:show={isShow}
     on:transitionend={onTransitionEnd}
>

    <div class="corner-message-area">
        <img class="icon" alt="" src={ImagePathConfig.CornerMessage.icon}/>
        { $cornerMessage }
    </div>
</div>
<style lang="scss">
    .corner-message-view {
        position: fixed;
        bottom: 0;
        left: 0;
        margin-left: 12px;


        padding-bottom: 12px;

        transform: translateY(100%);
        transition-duration: 1s;

        z-index: var(--corner-message-view-z-index);

        &.show {
            transform: translateY(0%);

        }

        .corner-message-area {
            border-style: solid;
            border-width: 1px;
            border-radius: 8px;

            border-color: var(--bana-red-color);
            //background-color: #fff;
            background-color: var(--bana-orange-color);
            color: var(--bana-white-color);

            padding-top: 0.5em;
            padding-bottom: 0.5em;
            padding-left: 1em;
            padding-right: 1em;

            font-size: 24px;

            min-height: 1em;

            display: flex;
            align-items: center;

            .icon {
                height: 1.5em;
                margin-right: 0.5em;
            }
        }

    }
</style>